var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_452_4959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_452_4959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.5563 -0.824707H27.5531V22.8249H-5.5563V-0.824707Z",
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.26376,
    y: -0.824707,
    width: 5.46897,
    height: 23.6496,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.55634 2.72266V4.57347L23.8515 19.2774H27.5531V17.4266L-1.8547 2.72597H-5.55634V2.72266ZM27.5531 2.72266V4.57347L-1.8547 19.2774H-5.55634V17.4266L23.8515 2.72266H27.5531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24037 2.72266V19.2774H13.7564V2.72266H8.24037ZM-5.55634 8.242V13.758H27.5531V8.242H-5.55634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.55634 9.34454V12.6555H27.5531V9.34454H-5.55634ZM9.34291 2.72266V19.2774H12.6539V2.72266H9.34291ZM-5.55634 19.2774L5.47904 13.758H7.95232L-3.08968 19.2774H-5.55634ZM-5.55634 2.72266L5.47904 8.242H3.01239L-5.55634 3.95764V2.72266ZM14.0478 8.242L25.0864 2.72266H27.5531L16.5177 8.242H14.0445H14.0478ZM27.5564 19.2774L16.5144 13.758H18.9811L27.5531 18.0424V19.2774H27.5564Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.29855,
    y: -0.824707,
    width: 3.36268,
    height: 23.6496,
    fill: "#DB5F7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.69d0fb162681e5cfd16d9e58aee0fc53.svg";
export { ForwardRef as ReactComponent };